<template>
  <svg
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ...attributes
  >
    <path
      d="M14.4643 8.94978C14.0738 8.55926 14.0738 7.92609 14.4643 7.53557L16.8346 5.16532C16.2792 4.8991 15.657 4.75 14.9999 4.75C12.6527 4.75 10.7499 6.65279 10.7499 9C10.7499 9.65705 10.899 10.2793 11.1652 10.8347L5.16397 16.8359C4.61168 17.3882 4.61168 18.2837 5.16397 18.8359C5.71625 19.3882 6.61168 19.3882 7.16397 18.8359L13.1652 12.8347C13.7206 13.1009 14.3429 13.25 14.9999 13.25C17.3471 13.25 19.2499 11.3472 19.2499 9C19.2499 8.35127 19.1046 7.73649 18.8447 7.18645L16.4799 9.55116C16.0894 9.94169 15.4562 9.94169 15.0657 9.55117L14.4643 8.94978Z"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
</template>
